<template>
   <div class="container-fluid cont search-section">
       <div id="searchbar">
           <input type="text" placeholder="Search..." v-model="value" @keyup.enter="enterClicked();">
           <router-link :to="{ name: 'Search', query: { search: value } }" id="searchbox" @click="toLower();push();">
               <div class="search-holder" @click="toLower();push();">
                   <img src="../../public/images/search.svg">
                </div>
           </router-link>
       </div>
       <div id="res-text">
           <h4 style="font-weight:bold;font-size:15px;">
               <p id="numm" style="display:inline;"></p>
                results for</h4>
           <h1 style="font-weight:bold;">{{ id }}</h1>
       </div>
       <div id="res-section">
           <div v-for="(record,i) in records" :key="record.id">
               <router-link :to="'/' + records[i].fields.Name ">
                   <div class="res-box">
                       <p class="res-title">Products</p>
                       <p>{{ records[i].fields.Type }}</p>
                   </div>
               </router-link>
           </div>
           <router-link to="/casestudy">
               <div class="res-box">
                   <p class="res-title">Case Study</p>
                   <p id="res-cstext">
                   </p>
               </div>
           </router-link>
       </div>
       <router-view :key="$route.fullPath"></router-view>
   </div>
</template>
 
<script>
import axios from 'axios';
import $ from 'jquery';
 
export default {
   name: 'Search',
   data () {
       return {
           apiUrl: 'https://api.airtable.com/v0/',
           apiKey: 'patuMyb6fwFAe9THH.ca32f9390ac6213308df3a99dc6fb185f635fe2d42d8020693e93ec6273f6d3f',
           base: 'appvYrkhR0QLHGIgm/Types?filterByFormula=SEARCH("',
           base2: '"%2C+%7BName%7D)',
           records: [],
           id: this.$route.query.search,
           hasCS: false,
           value: null,
       }
   },
   beforeRouteUpdate (to, from, next) {
       this.id = to.query.search;
       $("#numm").empty();
       this.getData();
       this.cscs();
       this.aa();  
       next()
   },
   mounted() {
       this.getData();
       this.cscs();
       this.aa();
       this.$data.id = this.$data.id.toLowerCase();
   },
   methods: {
       getData() {
           axios({
               url: this.apiUrl + this.base + this.id + this.base2,
               headers: {
                   'Authorization': `Bearer ${this.apiKey}`
               },
           }).then((res) => {
               this.records = res.data.records;
           });
       },
       cscs() {
           var searchID = this.id;
           var Airtable = require('airtable');
           var base = new Airtable({apiKey: 'patuMyb6fwFAe9THH.ca32f9390ac6213308df3a99dc6fb185f635fe2d42d8020693e93ec6273f6d3f'}).base('appvYrkhR0QLHGIgm');
           base('Case Study').select({
               filterByFormula: 'SEARCH("'+searchID+'", Text)',
               view: 'Grid view'
           }).firstPage(function(err, records) {
               if (err) { console.error(err); return; }
               else {
                   records.forEach(function(record) {
                       var csText = record.fields.Text.replace(/`/g, '');
                       $("#res-cstext").prepend(csText);
                       var regex = new RegExp(searchID, 'g');
                       var result = csText.replace(regex, '<b>' + searchID + '</b>');
                       $("#res-cstext").empty();
                       $("#res-cstext").prepend(result);
                   });
               }
           });
       },
       timer() {
           setTimeout(function () {   
               var count = $("#res-section").children().length;
               $("#numm").prepend(count);
           }, 1200);
       },
       aa() {
           this.timer();
       },
       toLower() {
           this.$data.value = this.$data.value.toLowerCase();
       },
       push() {
           this.$router.push('/search');
       },
       enterClicked() {
           this.id = this.value;
           this.toLower();
           document.getElementById("searchbox").click();
           document.activeElement.blur();
       }
   }
};
 
</script>
 
<style scoped>
   * {
       box-sizing: border-box;
       margin: 0;
       padding: 0;
       font-family: 'Forma DJR Micro', sans-serif;
   }
   a {
       text-decoration: none;
   }
   .cont {
       padding: 88px 7% 0 7%;
   }
   ::placeholder {
       color: #004884;
       font-style: italic;
       opacity: 0.8;
       font-size: 14px;
   }
   ::-webkit-input-placeholder {
       color: #004884;
       font-style: italic;
       opacity: 0.8;
       font-size: 14px;
   }
   :-moz-placeholder {
       color: #004884;
       font-style: italic;
       opacity: 0.8;
       font-size: 14px;
   }
   ::-moz-placeholder {
       color: #004884;
       font-style: italic;
       opacity: 0.8;
       font-size: 14px;
   }
   :-ms-input-placeholder { 
       color: #004884;
       font-style: italic;
       opacity: 0.8;
       font-size: 14px;
   } 
   #searchbar {
       margin-left: auto;
       width: 100%;
       padding-top: 15px;
       display: none;
   }
   #searchbar input {
       border: none;
       border-bottom: 1.5px solid #004984be;
       background: none;
       width: 95%;
       margin-right: 15px;
       outline: none;
       padding-bottom: 3px;
   }
   .search-holder {
       width: 25px;
       height: 25px;
       background: #E3E3E3;
       border-radius: 50px;
       display: flex;
       justify-content: center;
   }
   #res-text {
       padding: 65px 0 25px 0;
   }
   .res-box {
       width: 100%;
       height: auto;
       padding: 40px 30px;
       background: #EDEDED;
       margin-bottom: 25px;
       color:black;
   }
   .res-box:hover {
       border: 2px solid #004884;
       color: #004884;
   }
   .res-title {
       font-size:20px;
       font-weight:bold;
       padding-bottom:5px;
   }
   #res-cstext {
       text-align: justify;
       -webkit-box-orient: vertical;
       display: -webkit-box;
       -webkit-line-clamp: 3;
       overflow: hidden;
       text-overflow: ellipsis;
       white-space: normal;
   }
   @media screen and (max-width: 900px) {
       #searchbar {
           display: flex;
       }
   }
   @media screen and (max-width: 500px) {
       .cont {
           padding: 88px 20px 0 20px;
       }
       #res-section {
           margin-bottom: 70px;
       }
       #searchbar input {
           width: 90%;
       }
   }
</style>

